/************************************
 MODULE:         Language Selector
 WHAT IT DOES:   select language in dropdown
 *************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    var types = require('./types');


    function LanguageSelector(element) {

       this.element = element;
       this.$element = $(element);
       this.$links = this.$element.find('.js-language-selector__link');
       this.$nativeSelect = this.$element.find('.js-language-selector__native-select');

       this.type = this.element.getAttribute('data-type');

       setTimeout(this.init.bind(this), 0);

    }

    LanguageSelector.prototype.init = function() {
        switch (this.type) {
            case types.CUSTOM:
                this.initCustom();
                break;
            case types.NATIVE:
                this.initNative();
                break;

            default:
                this.initCustom();
                break;
        }
    };

    LanguageSelector.prototype.initCustom = function() {
        var Genericdropdown = require('generic.dropdown');

        var $content = this.$element.find('.js-language-selector__content');
        var $link = this.$element.find('.js-language-selector__trigger');


        this.dropdownInstance = new Genericdropdown(this.$element, {
            link: $link,
            content: $content,
            time: 0.2
        });
    };

    LanguageSelector.prototype.initNative = function() {
        this.createOptions();
        this.$nativeSelect.on('change', this.onNativeSelectChange.bind(this))
    };

    LanguageSelector.prototype.onNativeSelectChange = function(e) {
        var value = e.target.value;
        if (value !== "") {
            window.location.href = value;
            this.$nativeSelect[0].disabled = true;
        }
    };

    LanguageSelector.prototype.createOptions = function() {
        var selectedLabel = this.$element.data('selectedLabel');
        var options = '<option selected value="">' + selectedLabel + '</option>';
        this.$links.each(function(i, link) {
            var $link = $(link);
            var label = $link.data('label');
            var url = link.href;
            var option = "<option value='" + url + "'>" + label + "</option>";
            options += option;
        });


        this.$nativeSelect[0].innerHTML = options;
    };


    return LanguageSelector;

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/language-selector/language-selector.js
 ** module id = 69
 ** module chunks = 14
 **/